module.exports = __webpack_public_path__ + "assets/icons/avatar2.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/avatar/avatar2.png
// module id = ./src/styles/icons/avatar/avatar2.png
// module chunks = 0